// src/components/layout/PageHeader.jsx

import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';

export function PageHeader({
  title,
  showBack = false,
  onBack,
  actions = null,
  className = ''
}) {
  const navigate = useNavigate();

  return (
    <div className={cn('flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3', className)}>
      <div className="flex items-center gap-2">
        {/* Only show back button on desktop since mobile has it in the sticky header */}
        {showBack && (
          <button
            onClick={onBack || (() => navigate(-1))}
            className="hidden lg:block p-1 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[#0facd7]"
          >
            <ArrowLeft className="h-5 w-5 text-gray-600" />
          </button>
        )}
        <h1 className="text-xl sm:text-2xl font-semibold text-gray-900">{title}</h1>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}